<template lang="html">
<div class="wcc confirmation">
  <h2><font-awesome-icon :icon="['fa', 'check']"></font-awesome-icon>Email Sent</h2>
</div>
</template>
<script>
  export default {
  }
</script>
<style lang="scss">
  .wcc.confirmation {
    h2, p {
      color: $green;
      text-align: center;
    }
    h2 {
      margin-top: 0;
      svg {
        margin-right: $spacing * .3;
      }
    }
    h2:only-child {
      margin-bottom: 0;
    }
    p {
      margin: 0;
    }
  }
</style>